var Helpers = {
    Ajax: {},
    Arrays: {},
    LocalStorageLib: {},
    Numbers: {},
    Forms: {},
    Twitter: {},
    Facebook: {},
    CharacterCounter: {},
};

Helpers.Arrays = require('./_arrays')();

Helpers.Ajax = require('./_ajax')();
Helpers.Ajax.init();

Helpers.LocalStorageLib = require('./_localstoragelib')();
Helpers.LocalStorageLib.init();

Helpers.Numbers = require('./_numbers')();

Helpers.Forms = require('./_forms')();

Helpers.Urls = require('./_urls')();

Helpers.Objects = require('./_objects')();

Helpers.Twitter = require('./_twitter')();

Helpers.CharacterCounter = require('./_charactercounter')();

Helpers.Facebook = require('./facebookHelper');

if (!window.P2A) {
    window.P2A = {};
}
if (!window.P2A.Helpers) {
    window.P2A.Helpers = Helpers;
}